function handleEvent(_ref) {
  var event = _ref.event,
      method = _ref.method,
      props = _ref.props,
      value = _ref.value,
      payload = _ref.payload;
  props[method] && props[method](event, payload ? payload : {
    value: value
  });
}

export default handleEvent;
